<script setup lang="ts">
import { literal } from "zod";

const { defineOgMeta } = useSeoAttributes();

const pageMeta = usePageMeta();
const projects = useProjects();
const {
  public: { baseUrl },
} = useRuntimeConfig();

const [{ data: meta }, { pending, data: list }] = await Promise.all([
  useAsyncData("project-meta", async () => pageMeta.fetchByPath("/projects")),
  useAsyncData("project-industry", async () => projects.fetch()),
]);
const dataList = ref(list.value);

if (!list) {
  throw showError({
    statusCode: 404,
  });
}

if (meta.value) {
  useHead(() => ({
    title: meta.value?.title || "",
    titleTemplate: "%s | Webamboos",
    meta: [...defineOgMeta(meta.value)],
    link: [{ rel: "canonical", href: `${baseUrl}/projects` }],
  }));
}
</script>

<template>
  <Loader :pending="pending">
    <Container class="screen-content flex-1 px-0 pb-32">
      <LayoutPageHeader
        :title="dataList!.industry ? dataList!.industry.name : $t('home.projects.title')"
      />
      <section v-if="dataList" class="mt-8 flex flex-col gap-y-4 md:gap-y-20">
        <ProjectPreview
          v-for="(project, index) of dataList.projects"
          :key="project.slug"
          :project="project"
          :industry="dataList.industry"
          :is-mirrored="index % 2 !== 0"
        />
      </section>
    </Container>
  </Loader>
</template>
